import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Mining(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
      <polygon
        fill={backgroundColor}
        opacity={0.4}
        points="67.72 46.29 55.62 61.96 47.3 58.15 68.35 35.55 91.91 35.55 91.39 45.91 67.72 46.29"
      />
      <circle fill="none" stroke={iconColor} strokeMiterlimit={10} strokeWidth="2.33px" cx="37.7" cy="78" r="11.2" />
      <circle fill="none" stroke={iconColor} strokeMiterlimit={10} strokeWidth="2.33px" cx="73.98" cy="78" r="11.2" />
      <polygon
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="67.72 45.91 91.94 45.91 91.94 35.18 59.9 35.18 53.65 41.43 27.31 41.43 19.58 49.15 55.62 61.58 67.72 45.91"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="48.9"
        y1="78"
        x2="62.78"
        y2="78"
      />
      <polyline
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        points="87.13 45.91 91.08 56.48 96.73 56.48 96.73 78 88.89 78"
      />
      <line
        fill="none"
        stroke={iconColor}
        strokeMiterlimit={10}
        strokeWidth="2.33px"
        x1="71.03"
        y1="53.89"
        x2="82.56"
        y2="53.89"
      />
    </svg>
  );
}

Mining.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string
};

Mining.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02,
  backgroundColor: colors.iconGreen
};

export default Mining;
